module.exports = __webpack_public_path__ + "img/22203b2.jpg";